import { WellPermissionsSetInput } from "../../generated/graphql"
import { FormI } from "./types"
import _ from "lodash"

export const isSubmitFormDisabled = (
    initialForm: FormI,
    form: FormI,
    mutationError: boolean,
    isLoading: boolean
): boolean => {
    if (mutationError || isLoading) {
        return true
    }
    return _.isEqual(initialForm, form)
}

export const getWellPermissionsSetInput = (
    form: FormI
): WellPermissionsSetInput => {
    const managedAccess = !form.fullAccess

    const wIDs = form.wellPermissions
        .filter((well) => well.isSelected)
        .map((well) => well.value)

    const wellIDs = managedAccess ? wIDs : []

    return {
        membershipID: form.organizationMembershipId,
        managedAccess: managedAccess,
        wellIDs: wellIDs,
    }
}
